import { type IconProps } from './types';

export function Brain(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 2.5a5.5 5.5 0 0 0-4.8 2.8A4.5 4.5 0 0 0 3 9.5c0 1.3.6 2.5 1.5 3.3A4.5 4.5 0 0 0 3 16a4.5 4.5 0 0 0 4.2 4.5c.5 0 1 .2 1.3.5l1 1a2 2 0 0 0 2.5 0" />
      <path d="M12 2.5a5.5 5.5 0 0 1 4.8 2.8A4.5 4.5 0 0 1 21 9.5c0 1.3-.6 2.5-1.5 3.3A4.5 4.5 0 0 1 21 16a4.5 4.5 0 0 1-4.2 4.5c-.5 0-1 .2-1.3.5l-1 1" />
      <path d="M12 2.5v19.5" />
      <path d="M4.5 9.5c2 .5 4.5 1 7.5 1" />
      <path d="M19.5 9.5c-2 .5-4.5 1-7.5 1" />
      <path d="M4.5 16c2.5.5 5 .5 7.5 0" />
      <path d="M19.5 16c-2.5.5-5 .5-7.5 0" />
    </svg>
  );
}

export function Heart(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 7.5C10.5 4 7 2.5 4.5 4.5S1.5 10 4 12.5l7.5 8 .5.5.5-.5 7.5-8c2.5-2.5 2-6-.5-8S13.5 4 12 7.5z" />
      <path d="M12 7.5l-1.5 3 3 1-1.5 3" />
    </svg>
  );
}

export function Scale(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 3v18" />
      <path d="M8 21h8" />
      <path d="M4 7h16" />
      <path d="M4 7l2 8h0a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2h0l2-8" />
      <path d="M12 7l2 8h0a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2h0l2-8" />
    </svg>
  );
}
